exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".archival-wrap {\n\tmax-width: 600px;\n\tmargin: 0 auto;\n}\n\n.archival-wrap .mat-card {\n\tpadding: 10px 0 0;\n}\n\n.auto-list {\n\tmax-height: 430px;\n\toverflow-y: auto;\n}\n\n.auto-list > li,\n.delete-wrap {\n\tpadding: 10px 20px;\n\tborder-bottom: 1px solid #e6e6e6;\n}\n\n.auto-list > li:hover {\n\tbackground-color: #f4f4f4;\n}\n\n.auto-list .delete-icon {\n\tfont-size: 22px;\n\tcolor: #7f888f;\n\tmargin-top: 5px;\n}\n\n.highlightedRow {\n\tbackground-color: #039be5;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/services/service.component.css
// module id = 1931
// module chunks = 0